// extracted by mini-css-extract-plugin
export default {"editIcon":"ReportsTable_editIcon__+5OKj","deleteIcon":"ReportsTable_deleteIcon__cBCSv","table":"ReportsTable_table__Chukx"};